export default __webpack_public_path__ + "static/media/YO Logo Transparent.d0e2d505.png";